module.exports = __webpack_public_path__ + "static/media/cookhouse-secondary.83da5a89.jpg";